




































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';

import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import Select from '@/components/Select.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { InvoiceListProfileResponse, InvoiceProfile, User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';

interface LabelValue {
  label: string;
  value: number;
}

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SearchIcon,
    ExportIcon,
    Select,
    SearchField,
    SearchRow,
  },
  computed: mapState(['user']),
})
export default class ReportEinvoice extends Vue {
  autoGenerateTransactionNumber = true;
  viaEmail = false;
  viaSMS = false;
  viaWA = false;
  profiles: InvoiceProfile[] = [];
  profileList: LabelValue[] = [];
  selectedProfile: LabelValue | null = null;
  currentProfile: InvoiceProfile | null = null;
  loadingProfile = true;
  merchantId = 0;
  file: File | null = null;

  user!: {
    user: User;
  };

  $refs!: {
    'file-input': HTMLInputElement;
  }

  openFileInput() {
    this.$refs['file-input'].click();
  }

  async getProfile() {
    try {
      this.loadingProfile = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceListProfileResponse>('/easyinvoice/invoices_list_profile', {
        user_group: 5,
        merch_id: this.merchantId,
      });

      this.profiles = data.profile;
      this.profileList = data.profile.map((e, i) => ({
        label: e.name,
        value: i,
      }));

      this.loadingProfile = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('selectedProfile')
  onProfileChange() {
    if (this.selectedProfile === null) return;

    const index = this.selectedProfile.value;
    const profile = this.profiles[index];
    this.currentProfile = profile;

    this.viaEmail = this.currentProfile.channel_mail === '1';
    this.viaSMS = this.currentProfile.channel_sms === '1';
    this.viaWA = this.currentProfile.channel_wa === '1';
  }

  async onFileDrag(event: DragEventInit) {
    if (!event.dataTransfer) return;
    const [file] = event.dataTransfer.files;

    this.checkFile(file);
  }

  async onFileInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const { files } = target;

    if (files === null || files.length === 0) return;
    const file = files[0];

    this.checkFile(file);
  }

  // eslint-disable-next-line class-methods-use-this
  async checkFile(file: File) {
    if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.file = file;
    } else if (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') {
      this.file = file;
    } else {
      showToast(ToastType.FAILED, 'Invalid file', 'File Format must be Ms. Excel (XLSX) or CSV');
    }
  }

  async sendIvoice() {
    if (!this.viaSMS && !this.viaEmail) {
      showToast(ToastType.FAILED, 'Choose Channel',
        'Please select one of Channel for sending invoice to process sent bulk invoice.');
      return;
    }
    if (this.currentProfile === null) {
      showToast(ToastType.FAILED, 'Choose Profile',
        'Please select one of the Profile for sending invoice to process sent bulk invoice.');
      return;
    }

    const formData = new FormData();
    formData.append('user_group', '5');
    formData.append('merch_id', this.currentProfile.mid);
    formData.append('auto_transaction_number_bulk', this.autoGenerateTransactionNumber ? 'yes' : 'no');
    formData.append('channel_bulk_email', this.viaEmail ? 'yes' : 'no');
    formData.append('channel_bulk_sms', this.viaSMS ? 'yes' : 'no');
    formData.append('channel_bulk_wa', this.viaWA ? 'yes' : 'no');
    formData.append('excel_file', this.file as File);
    formData.append('profile_id', this.currentProfile.id);
    formData.append('user_id', this.user.user.id.toString());
    const { data } = await api.post('easyinvoice/invoices_create_bulk', formData);

    if (data.status === '01') {
      showToast(ToastType.FAILED, data.case, data.message.join(', '));
    } else if (data.status === '00') {
      showToast(ToastType.SUCCESS, 'Success', data.message);
      this.$router.push('/easyinvoice/einvoice/invoicebatch');
    }
  }

  mounted() {
    this.merchantId = this.user.user.merchant_id;
    this.getProfile();
  }
}
